<template>
    <form>
        <h3>Section One - Eligibility</h3>
        <RadioSet :options="opYN" prompt="Are you currently a secondary school student?" name="secondarystudent"   v-model="$parent.rec.secondarystudent"/>
        <RadioSet :options="opYNU" prompt="Are you descended from an indigenous Pacific person?" name="descendant" v-model="$parent.rec.descendant"/>
        <template v-if="isEligable">
        <label class="full2"><span class="divider"><strong id="__myschool">Your School</strong></span>
        <!-- <RazorSwitch style="justify-self:center" :kv="{'All Schools':0,'~5Km':5,'~60Km':60}" parentdata="schoolFilter"/>
        <select v-if="this.list.length" name="myschool" v-model="$parent.rec.myschool">
            <option v-for="(r,i) in filteredSchoolsList" :key="i" :value="r.Org_Name">{{r.Org_Name}}</option>
        </select> -->
        <input type="text" @blur="checkForSub" required list="secondarySchools" autocomplete="off" name="myschool" v-model="$parent.rec.myschool">
        </label>
        <RadioSet isCompact=true :options="opYear" prompt="What is your current year?" name="schoolyear" v-model="$parent.rec.schoolyear"/>
        <template v-if="$parent.rec.schoolyear>10">
            <h4 class="divider">Subjects <span class="red">{{subjectIssue}}</span></h4>
            <div class="cb-box">
                <t2-checkbox  v-if="$parent.rec.schoolyear<12" label="General Science" v-model="$parent.rec.science" />
                <t2-checkbox label="Biology" v-model="$parent.rec.biology" />
                <t2-checkbox label="Chemistry" v-model="$parent.rec.chemistry" />
                <t2-checkbox label="Physics" v-model="$parent.rec.physics" />
                <t2-checkbox label="Maths" v-model="$parent.rec.maths" />
                <t2-checkbox label="Calculus" v-model="$parent.rec.calculus" />
                <t2-checkbox label="Statistics" v-model="$parent.rec.statistics" />
                <t2-checkbox label="English" v-model="$parent.rec.english" />
                <t2-checkbox label="History" v-model="$parent.rec.history" />
                <t2-checkbox label="Classical studies" v-model="$parent.rec.classical" />
                <t2-checkbox label="Geography" v-model="$parent.rec.geography" />
                <t2-checkbox label="Art history" v-model="$parent.rec.art_history" />
                <!-- <t2-checkbox label="Maths" v-model:otherValue="$parent.rec.mathsSpecify" v-model="$parent.rec.maths" other="Specify Calculus/Statistics" />
                <t2-checkbox label="English-rich subject" v-model:otherValue="$parent.rec.englishSpecify" v-model="$parent.rec.english" other="Specify" /> -->
            </div>
        </template>
        <span class="divider"> </span>
        <RadioSet :options="opYNU" prompt="Are you interested in pursuing a career in Health?" name="interested" v-model="$parent.rec.interested"/>
        <footer><button @click.prevent="chkNextTab">Next</button></footer>
        </template>
        <div
            v-if="$parent.rec.secondarystudent=='No'||$parent.rec.descendant=='No'"
            class="stop">Sorry, you are not eligible for this programme.
        </div>
        <datalist id="secondarySchools">
            <option v-for="(r,i) in list" :key="i" :data-id="r.School_Id">{{r.Org_Name}}</option>
        </datalist>
    </form>
</template>

<script>
import RadioSet from '@/components/radio-set.vue'
import T2Checkbox from '@/components/t2-checkbox.vue'
// import RazorSwitch from '@/components/razorSwitch.vue'
export default {
    name:"section 1",
    components:{RadioSet,T2Checkbox/*,RazorSwitch*/},
    data: function (){return {
        schoolFilter:0,
        curlocation:undefined,
        subjectIssue:"",
        list: [],
        opYN: ["Yes","No"],
        opYear: ["9","10","11","12","13"],
        opYNU: ["Yes","No","Unsure"]
    }},
    watch: {
        schoolFilter(newval){
            if (newval>0 && !this.location){
                // get the device geolocation
                if (!this.curlocation)
                    if (navigator.geolocation)
                        navigator.geolocation.getCurrentPosition(this.setLocation, this.locationError);
            }
        }
    },
    computed:{
        isEligable: function(){
            return this.$parent.applicantEligable();
        },
        filteredSchoolsList: function(){
            const loc = this.curlocation;
            if (this.schoolFilter==0||!loc)
                return this.list;
            if (typeof (Number.prototype.toRad) === "undefined") {
                Number.prototype.toRad = function () {
                    return this * Math.PI / 180;
                }
            }
            const dist = this.schoolFilter;
            return this.list.filter(u=>{
                let radlat1 = loc.latitude.toRad();
                let radlat2 = u.Latitude.toRad();
                let deltalon = (loc.longitude - u.Longitude);
                let raddl = deltalon.toRad();
                let km = Math.acos(Math.sin(radlat1) * Math.sin(radlat2) +
                    Math.cos(radlat1) * Math.cos(radlat2) *
                    Math.cos(raddl)) * 6371; // 6371km == mean radius of earth
                return (km <= dist);
            });
        }
    },
    methods:{
        setLocation(position){
            this.curlocation = position.coords;
        },
        chkNextTab: function(){
            if (this.allGood())
                this.$parent.nextTab();
        },
        locationError(){
            // nothing to do here?
        },
        checkForSub: function(){
            // the school name might be a non-macroned substitute
            //debugger;//eslint-disable-line
            let ss = document.getElementById("secondarySchools");
            if (!ss)
                return;
            let allOptions = Array.from(ss.options);
            let thisSubedSchool = allOptions.find(op=>op.textContent=='\t'+this.$parent.rec.myschool);
            if (thisSubedSchool){
                let propperId = thisSubedSchool.dataset.id * -1;
                let propper = allOptions.find(u=>u.dataset.id==propperId);
                if (propper)
                    this.$parent.rec.myschool = propper.textContent;
            }
        },
        allGood: function(){
            let science = ["biology", "chemistry", "physics", "science"];
            if (this.$parent.rec.secondarystudent == "Yes") {
                let notfilled = ["schoolyear","myschool","interested","descendant"];
                // notfilled.map(u=>Object.assign({},{n:u,v:this.$parent.rec[u]})).filter(u=>u.v=="");
                notfilled = notfilled.filter(u=>this.$parent.rec[u]=="");
                if (this.$parent.rec.schoolyear>10){
                    let countScience = 0;
                    science.forEach(subject=>{if (this.$parent.rec[subject]) countScience++});
                    this.subjectIssue = (countScience==0)?"you need at least one science subject.":"";
                }
                if (notfilled.length==0 && this.subjectIssue=="")
                    return true;
            }
            return false;
        },
        sortByName: function (a,b){
            return a.Org_Name.localeCompare(b.Org_Name);
        },
        transChin: function(t){
            return t.replace(/\ud6ee|\ud771|\ud772|\ud070/g,(m)=>{return {'\ud6ee':'\u0101','\ud070':'\u016b','\ud771':'\u014c','\ud772':'\u014d'}[m]});
        }
    },
    mounted: async function(){
        let transmacron = {"ā":"a","ī":"i","ō":"o","ū":"u",Ā:"A",Ī:"I",Ō:"O",Ū:"U"};
        let macsub = function(ch){
            let non = transmacron[ch];
            return non?non:ch;
        }

        /*   New Zealand Schools Dataset provided by
         *   https://catalogue.data.govt.nz/dataset/directory-of-educational-institutions
         *   Creative Commons Attribution 4.0 International
        */
       // get all records that go up to year 15
        //let resp = await fetch("https://catalogue.data.govt.nz/api/3/action/datastore_search?resource_id=20b7c271-fd5a-4c9e-869b-481a0e2453cd&q=-15)&limit=600");
        let resp = await fetch("https://catalogue.data.govt.nz/api/3/action/datastore_search?resource_id=4b292323-9fcc-41f8-814b-3c7b19cf14b3&q=-15)&limit=600");
        let json = await resp.json();
        this.list = json.result.records.filter(u=>u.Email&&u.Org_Type!="Full Primary").map(org=>{return {School_Id:org.School_Id, Org_Name:this.transChin(org.Org_Name)}});
        // now get any composite schools
        //resp = await fetch("https://catalogue.data.govt.nz/api/3/action/datastore_search?resource_id=20b7c271-fd5a-4c9e-869b-481a0e2453cd&q=Composite&limit=600");
        resp = await fetch("https://catalogue.data.govt.nz/api/3/action/datastore_search?resource_id=4b292323-9fcc-41f8-814b-3c7b19cf14b3&q=Composite&limit=600");
        json = await resp.json();
        console.log(this.list.length, json.result.records.length);
        // this.list = this.list.concat(json.result.records.map(org=>{return {School_Id:org.School_Id, Org_Name:this.transChin(org.Org_Name)}}));
        // find school names that contain at least 1 macron character, add unmacronised version with space prepended
        let extras = [];
        this.list.forEach(school=>{
            let nō = school.Org_Name.split("").map(ch=>macsub(ch)).join("");
            if (nō !== school.Org_Name)
                extras.push({School_Id:school.School_Id*-1, Org_Name:"\t"+nō});
        });
        this.list = this.list.concat(extras);
        this.list.sort(this.sortByName);
    }
}
</script>

<style>
.stop {
    background-color: var(--color-warning);
    padding: 2em 0.5em;
    text-align: center;
    grid-column: span 2;
}
.red {
    color: var(--color-error);
    font-weight: normal;
}
</style>
{name:"Whangarei", value:"Whangarei"},
{name:"Auckland", value:"Auckland"},
{name:"Waikato", value:"Waikato"},
{name:"Rotorua", value:"Rotorua"},
{name:"Tauranga", value:"Tauranga"},
{name:"New Plymouth", value:"New Plymouth"}